<template>
  <div class="contentBox rightSide">
    <SectionTitleBar v-on:buttonPress="closeVideoPlayer()" :buttonText="'Close'" />
    <div class="unassignedDeliverables">
      <draggable group="deliverableBatch" ghost-class="ghost" handle=".dragFixed" v-model='videoListModel'>
        <VideoQueueRow v-for="video in unassignedVideos" :video="video" :key="video.id"/>
      </draggable>
      <div class="addNewDeliverable clickable" v-on:click="createDeliverable"><span class="material-icons">add_circle</span></div>
    </div>

  </div>
</template>

<script>
import SectionTitleBar from '../components/SectionTitleBar.vue'
import VideoQueueRow from '../components/VideoQueueRow.vue'
import draggable from 'vuedraggable'

export default {
  data() {
    return {
    }
  },
  name: 'RightHandRail',
  components: {
    draggable,
    VideoQueueRow,
    SectionTitleBar
  },
  methods: {
    closeVideoPlayer: function(){
      //this.$store.commit('closeVideoPlayer');
    },
    createDeliverable () {
      var currentClientRef = this.$store.state.clientCollection[this.$store.state.selectedClient].ref
      this.$store.dispatch("createDeliverable",currentClientRef)
    }
  },
  computed: {
    videoListModel: {
      get() {
        return this.unassignedVideos
      },
      set(videoArray) {
        this.$store.dispatch('updateBatchMembership',[null,videoArray])
      }
    },
    unassignedVideos (){
      return this.$store.getters.getVideosWithoutBatch
    },
    currentVideo () {
      return this.$store.state.currentVideo
    },

  }
}
</script>

<style lang="scss">
  .rightSide {
    display: flex;
    justify-content: center;
    width: 400px;
    margin-left: 15px;
  }
  .unassignedDeliverables {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 1;
    >div {
      min-height: 70px;
      min-width: 325px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
  .addNewDeliverable {
    display: flex;
    align-items: center;
    width: 325px;
    margin: 10px;
    padding: 10px;
    background-color: #3E4567;
    border: 1px dashed #6A7CE9;
    border-radius: 5px;
    span {
      color: #6A7CE9
    }
  }
</style>
